import React from 'react';

import { FlatButton } from '@travel/ui';
import { Calendar } from '@travel/icons/ui';
import { cx } from '@travel/utils';
import { useTranslation } from '@travel/traveler-core/hooks';

import styles from './smallDateButton.module.scss';

type Props = {
  className?: string;
  /** Date string of start date */
  startDate?: string;
  /** Date string of end date */
  endDate?: string;
  /** Callback to be called when button is clicked */
  onClick: () => void;
  /** Date component to specify custom format */
  DateComponent: React.ComponentType<{ value: string }>;
};

function SmallDateButton(props: Props) {
  const { className, startDate, endDate, onClick, DateComponent } = props;
  let displayText: React.ReactNode = useTranslation({ id: 'Top.Check_In_Out' });

  if (startDate && endDate) {
    displayText = (
      <>
        <DateComponent value={startDate} />
        &nbsp;-&nbsp;
        <DateComponent value={endDate} />
      </>
    );
  }

  return (
    <FlatButton
      isSmallerButtonByDefault
      icon={<Calendar size={24} color="default" />}
      onClick={onClick}
      className={cx(styles.button, startDate && endDate ? '' : styles.placeholder, className)}
      data-testid="smallDateButton-button"
    >
      {displayText}
    </FlatButton>
  );
}

export default SmallDateButton;
